module.exports = __webpack_public_path__ + "static/media/upload.4de185d5.gif";